// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3DDzt","title":"Info_title__1RXmt","links":"Info_links__25hZh","link":"Info_link__2hr3L","logo":"Info_logo__3j0Ci"};